var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',_vm._b({ref:"pager",staticClass:"relative",attrs:{"showSizer":"","showElevator":"","page-size-opts":_vm.pagesizes,"show-total":""},on:{"on-change":_vm.changePage,"on-page-size-change":_vm.changePageSize}},'Page',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }